/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_1_DescInputs */

const en_mk_sec_1_desc = /** @type {(inputs: Mk_Sec_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending email/WhatsApp, posting socially, changing financial data — all wait for a click of approval.`)
};

const id_mk_sec_1_desc = /** @type {(inputs: Mk_Sec_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim email/WA, posting sosial, ubah data keuangan — semua menunggu klik setuju.`)
};

/**
* | output |
* | --- |
* | "Sending email/WhatsApp, posting socially, changing financial data — all wait for a click of approval." |
*
* @param {Mk_Sec_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_1_desc = /** @type {((inputs?: Mk_Sec_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_1_desc(inputs)
	return en_mk_sec_1_desc(inputs)
});